import { render, staticRenderFns } from "./CommentManagement.vue?vue&type=template&id=3ef40f30&scoped=true"
import script from "./CommentManagement.vue?vue&type=script&lang=js"
export * from "./CommentManagement.vue?vue&type=script&lang=js"
import style0 from "./CommentManagement.vue?vue&type=style&index=0&id=3ef40f30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef40f30",
  null
  
)

export default component.exports